import { useEffect, useState } from "react";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { RentalInformations, RentalInformationsV2 } from "@/interfaces/checkIn";

type RequestError = {
  status: number;
  title: string;
};

export const useFetchRentalInformations = (cacheId: string) => {
  const [rentalInformations, setRentalInformations] = useState<
    RentalInformations | undefined
  >(undefined);
  const [isError, setIsError] = useState<RequestError | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (cacheId !== "") {
      sendFetchRequest(`/customers/v1/checkin/getBookingData/${cacheId}`)
        .then((response: RentalInformations) => {
          setRentalInformations(response);
          setIsLoading(false);
        })
        .catch((e: RequestError) => {
          setIsError(e);
          setIsLoading(false);
        });
    }
  }, [cacheId]);

  return {
    rentalInformations: rentalInformations,
    error: isError,
    isLoading: isLoading,
  };
};

export const useFetchRentalInformationsV2 = (cacheId: string) => {
  const [rentalInformations, setRentalInformations] = useState<
    RentalInformationsV2 | undefined
  >(undefined);
  const [isError, setIsError] = useState<RequestError | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (cacheId !== "") {
      sendFetchRequest(`/customers/v2/checkin/getBookingData/${cacheId}`)
        .then((response: RentalInformationsV2) => {
          setRentalInformations(response);
          setIsLoading(false);
        })
        .catch((e: RequestError) => {
          setIsError(e);
          setIsLoading(false);
        });
    }
  }, [cacheId]);

  return {
    rentalInformations: rentalInformations,
    error: isError,
    isLoading: isLoading,
  };
};
